module.exports = __webpack_public_path__ + "static/media/rounds_back_2.03bd65c6.svg";